import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, TextField, TextFieldProps } from '@mui/material'

import styles from './styles.module.scss'

interface SeachProps {
  onChange?: (value: any) => void
  label?: string
  value?: string
}

export const Search = ({
  onChange,
  label,
  value,
  ...rest
}: SeachProps & TextFieldProps) => {
  return (
    <div className={styles.container}>
      <TextField
        sx={{ width: '100%' }}
        name="search"
        type="text"
        size="small"
        value={value ?? ''}
        label={label || 'Pesquisar'}
        className={styles.input}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        onChange={onChange}
        {...rest}
      />
    </div>
  )
}
